import React, { Component } from "react";
import DashboardLayout from "../../../templates/dashboard-template/index";
import CreditMemoTable from "../../../components/Table/CreditMemo/CreditMemoTable";
// import "./style.scss";

 
class CreditMemo extends Component {
  
  render() {
    return (
     <DashboardLayout> 
        <div className="page-header-title">
            <h5 className="m-b-10">Credit Memo</h5>
        </div> 
        <div className="page-container">
          {/* <div className="page-container-header">  
              <div></div> 
              <div>SEARCH</div> 
              <div>PAGINATION</div> 
          </div> */}
          {/* <div className="page-container-filter-bar"> 
                <div className="form-inline filter-form"> 
                  FILTERS
                </div>   
            </div>  */}
          <CreditMemoTable/>
        </div>  
     </DashboardLayout> 
    );
  }
}
export default CreditMemo;